import { Links, Meta, Outlet, Scripts, ScrollRestoration } from "react-router";
import { ToastContainer } from "react-toastify";
import toastifyHref from "react-toastify/dist/ReactToastify.css?url";
import { ThemeProvider } from "~/components/theme-provider";
import tailwindHref from "~/tailwind.css?url";

export const links = () => [
	{ rel: "stylesheet", href: tailwindHref },
	{ rel: "stylesheet", href: toastifyHref },
];
export function Layout({ children }: { children: React.ReactNode }) {
	return (
		<html lang="ja" suppressHydrationWarning={true}>
			<head>
				<meta charSet="utf-8" />
				<meta name="viewport" content="width=device-width, initial-scale=1" />
				<Meta />
				<Links />
			</head>
			<body>
				<ThemeProvider
					attribute="class"
					defaultTheme="dark"
					enableSystem={false}
				>
					<main className="">{children}</main>
					<ToastContainer
						position="top-center"
						className="!z-[1000]"
						toastStyle={{ width: "480px" }}
					/>
				</ThemeProvider>
				<ScrollRestoration />
				<Scripts />
			</body>
		</html>
	);
}

export default function App() {
	return <Outlet />;
}

export function HydrateFallback() {
	return <p>Loading...</p>;
}
